import { ConsumptionTypeEnum } from '@schemas/scenarios-simulator/enums';
import { TARIFF } from '@utils/constants';

const CONSUMPTION_TYPE_BY_TARIFF: Record<keyof typeof TARIFF, ConsumptionTypeEnum> = {
  A4_GREEN: ConsumptionTypeEnum.MEDIUM_VOLTAGE_GREEN,
  A4_BLUE: ConsumptionTypeEnum.MEDIUM_VOLTAGE_BLUE,
  AS_BLUE: ConsumptionTypeEnum.MEDIUM_VOLTAGE_BLUE,
  AS_GREEN: ConsumptionTypeEnum.MEDIUM_VOLTAGE_GREEN,
  A3_BLUE: ConsumptionTypeEnum.MEDIUM_VOLTAGE_BLUE,
  A2_BLUE: ConsumptionTypeEnum.MEDIUM_VOLTAGE_BLUE,
  B3_STANDARD: ConsumptionTypeEnum.LOW_VOLTAGE,
  B3_OPTING: ConsumptionTypeEnum.LOW_VOLTAGE,
};

export const getConsumptionTypeFromTariff = (tariffGroup: unknown): ConsumptionTypeEnum | undefined => {
  if (
    typeof tariffGroup !== 'string' ||
    !Object.prototype.hasOwnProperty.call(CONSUMPTION_TYPE_BY_TARIFF, tariffGroup)
  ) {
    return undefined;
  }
  return CONSUMPTION_TYPE_BY_TARIFF[tariffGroup as keyof typeof TARIFF];
};
